<template>
  <div class="car-accordion" :class="{'car-open': open}">
    <div class="car-accordion-label" @click="toggle">
      <span class="car-text">{{label}}</span>
      <span v-if="logo" class="car-icon">
      </span>
      <span v-else class="car-toogle-text">
        <span v-if="open">{{$t('offer.hideDetails')}}</span>
        <span v-else>{{$t('offer.showDetails')}}</span>
      </span>
    </div>
    <div v-if="open" class="car-accordion-content">
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Accordion',
  data() {
    return {
      open: this.expand
    };
  },
  props: {
    label: {
      default: ''
    },
    logo: {
      default: true
    },
    expand: {
      default: false
    }
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
};
</script>
